/**
 * 支付类型
 */
export const PAY_TYPE = {
  TRANSFER: 'TRANSFER',   // 支付宝/微信转账
  BALANCE: 'BALANCE'      // 余额支付
}

